import { useEffect, useState } from '@root/vendor/react';
import { useLocation } from '@reach/router';

export default function usePageSearch() {
  const location = useLocation();
  const [search, setSearch] = useState('');
  useEffect(() => { setSearch(location.search); }, [location.search]);
  return search;
}
